  export const environment = {
    production: false,
    serverUrl: 'https://rgudvikpsh.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'sanofi-dev-upload',
    userPool: {
      UserPoolId: 'us-east-2_1VO8X6ZrO',
      ClientId: '6l7dph0k40mld3pvn6p7tha7bf',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:7636a67e-9ab1-43fc-a2b9-b84888a21577',
    buckets: {
      'us-east-2': 'sanofi-dev-upload'
    },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId:'us-east-2:7636a67e-9ab1-43fc-a2b9-b84888a21577', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_1VO8X6ZrO', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '6l7dph0k40mld3pvn6p7tha7bf', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'sanofi-dev-upload', //REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', //OPTIONAL -  Amazon service region
      }
    }
  };

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '6l7dph0k40mld3pvn6p7tha7bf',
      userPoolId: 'us-east-2_1VO8X6ZrO',
      identityPoolId: 'us-east-2:7636a67e-9ab1-43fc-a2b9-b84888a21577'
    }
  },
  Storage: {
    S3: {
      bucket: 'sanofi-dev-upload',
      region: 'us-east-2'
    }
  }
};
export default awsconfig;